import { formatNumber } from 'components/utils/numbers'
import { SectionTitle, ParagraphSm } from 'components/display/Typography'
import { CallToActionButton } from '../shared'
import ImageGrid from './ImageGrid'
import { Outer, Content, BoldHeading, LightHeading } from './styles'

type FulfillingMomentsProps = {
  count: number
}

const FulfillingMoments = ({ count }: FulfillingMomentsProps) => {
  return (
    <Outer>
      <Content>
        <SectionTitle>Our impact</SectionTitle>
        <h2>
          <BoldHeading data-testid="moment-count">
            {formatNumber(count)}
          </BoldHeading>{' '}
          <LightHeading>Fulfilling moments</LightHeading>
        </h2>
        <ParagraphSm>
          Since 2018, we’ve been measuring our community’s fulfillment after
          every short nature escape.
        </ParagraphSm>
        <CallToActionButton
          as="a"
          href="/about"
          fullwidth={false}
          rounded
          ghost
        >
          Read our story
        </CallToActionButton>
      </Content>

      <ImageGrid />
    </Outer>
  )
}

export default FulfillingMoments
